import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { createInfraredJob } from "features/pubsub/entityActions/jobs/infrared"
import { deactivateHotspotOrthoOverlapLayerAction } from "features/entity-caching/flights/slice"
import { selectActiveLayerId } from "panels/content/side-panel/slice.new"
import { InfraredProcessingMode } from "@nova/constants"

export const useProcessing = () => {
    const dispatch = useAppDispatch()
    const activeLayerId = useAppSelector(selectActiveLayerId)

    const beginDetection = async (mode?: InfraredProcessingMode, imageCount?: number) => {
        if (!activeLayerId) return
        dispatch(
            createInfraredJob({
                data: { processingMode: mode ?? InfraredProcessingMode.General },
                context: { flightId: activeLayerId, imageCount },
            })
        )
        dispatch(deactivateHotspotOrthoOverlapLayerAction({ id: activeLayerId }))
    }

    return { processCallback: beginDetection, dependencies: [dispatch] }
}
